export default {
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m),
  error: () => import("/app/src/layouts/error.vue").then(m => m.default || m)
}